import { render, staticRenderFns } from "./MobileQA.vue?vue&type=template&id=3310f8d3"
import script from "./MobileQA.vue?vue&type=script&lang=ts"
export * from "./MobileQA.vue?vue&type=script&lang=ts"
import style0 from "./MobileQA.vue?vue&type=style&index=0&id=3310f8d3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports